
const defaultLanguage = 'ja'; //默认语言

export default defaultLanguage;